import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";

// import Header from "./components/Header";
import Footer from "./components/Footer";
import Navbar from "./components/Navbar";

import Home from "./components/home/Home";
import Courses from "./components/courses/CoursesPage";

import About from "./components/pages/AboutPage";
import Contact from "./components/pages/ContactPage";
import Partnerships from "./components/pages/PartnershipsPage";
import Testimonials from "./components/pages/TestimonialsPage";
import Events from "./components/pages/Events"

import CourseDetailPage from "./components/pages/CourseDetailPage";

import PrivacyPolicyPage from "./components/pages/PrivacyPolicyPage";
import TermsOfServicePage from "./components/pages/TermsOfServicePage";
import CookiePolicyPage from "./components/pages/CookiePolicyPage";


export default function App() {
  return (
    <BrowserRouter>
      <div className="app-root">
        {/* <Header /> */}
        <Navbar/>
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/courses" element={<Courses />} />
            <Route path="/courses/:id" element={<CourseDetailPage />} />
            <Route path="/events" element={<Events/>}/>
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/partnerships" element={<Partnerships />} />
            <Route path="/testimonials" element={<Testimonials />} />
            
<Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
<Route path="/terms-of-service" element={<TermsOfServicePage />} />
<Route path="/cookie-policy" element={<CookiePolicyPage />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </BrowserRouter>
  );
}
